import type { api } from '@meterup/proto';
import { capitalize } from 'lodash-es';
import { DateTime } from 'luxon';
import * as z from 'zod';

export const DETAILS = 'details';
export const DURATION = 'duration';

export const CATEGORY_NONE = '';
export const CATEGORY_INSTALLATION = 'installation';
export const CATEGORY_DEINSTALLATION = 'deinstallation';
export const CATEGORY_MAINTENANCE = 'maintenance';
export const CATEGORY_OUTAGE = 'outage';

export const categories = [
  CATEGORY_NONE,
  CATEGORY_INSTALLATION,
  CATEGORY_DEINSTALLATION,
  CATEGORY_MAINTENANCE,
  CATEGORY_OUTAGE,
];

export const categoryOptions = categories.map((key) => ({
  key,
  label: key ? capitalize(key) : 'None',
}));

export const toIncidentCreateRequest = (
  data: ValidIncidentData,
  timezone: string,
): {
  incidentData: api.UpsertControllerIncidentRequest;
} => ({
  incidentData: {
    start_time: data.start_time
      ? DateTime.fromISO(data.start_time, { zone: timezone }).toISO()
      : undefined,
    end_time: data.end_time
      ? DateTime.fromISO(data.end_time, { zone: timezone }).toISO()
      : undefined,
    notes: data.notes,
    category: data.category,
  },
});

export const toIncidentUpdateDurationRequest = (
  data: ValidIncidentData,
  timezone: string,
): {
  incidentData: api.UpsertControllerIncidentRequest;
} => ({
  incidentData: {
    start_time: data.start_time
      ? DateTime.fromISO(data.start_time, { zone: timezone }).toISO()
      : undefined,
    end_time: data.end_time
      ? DateTime.fromISO(data.end_time, { zone: timezone }).toISO()
      : undefined,
    notes: data.notes,
    category: data.category,
  },
});

export type ValidIncidentData = z.infer<typeof validIncidentData>;

export const validIncidentData = z.object({
  start_time: z.string(),
  end_time: z.string(),
  notes: z.string().optional(),
  category: z.string().optional(),
});
